import { useOidc } from '@axa-fr/react-oidc';
import IconHelp from '@iconify/icons-material-symbols/help-outline';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Icon } from '#pie/components/icon/Icon';
import { LanguageSwitch } from '#pie/components/language-switch/LanguageSwitch';
import { HeaderProfile } from './profile/HeaderProfile';

export const Header = () => {
  const { isAuthenticated } = useOidc();
  const { t } = useTranslation();

  return (
    <header className="flex w-full items-center justify-between gap-6 bg-surface-base px-6 py-3">
      <div className="flex-1"></div>
      <div className="flex items-center gap-4">
        <Link
          to="/support"
          title={t('support.title')}
          className="flex items-center"
        >
          <Icon
            icon={IconHelp}
            size={24}
            className="text-content-heading hover:text-action-primary-hover"
          />
        </Link>
        <div className="flex items-center">
          <LanguageSwitch />
        </div>
        <div className="flex shrink-0 items-center self-stretch border-l border-border-divider" />
        <div>{isAuthenticated && <HeaderProfile />}</div>
      </div>
    </header>
  );
};
